<template>
  <div class="dashboard" v-visible-track="'Iframe.ancientDnaReportsMainScreenPageViewed'">
    <template v-if="$store.state.appConfig.windowWidth >= 769">
      <div class="dashboard-desktop">
        <app-sidebar />
        <div class="dashboard-wizard">
          <app-wizard />
        </div>
      </div>
    </template>
    <template v-else>
      <app-sidebar />
    </template>
  </div>
</template>

<script>
import AppSidebar from '../components/layout/AppSidebar.vue';
import AppWizard from '@/components/layout/AppWizard.vue';

export default {
  name: 'DashboardPage',
  components: {
    AppSidebar,
    AppWizard,
  },
  methods: {
  },
};
</script>    

<style lang="scss" scoped>
.dashboard {
  .dashboard-desktop {
    width: 100%;
    display: flex;
    background-image: url("@/assets/svg/WizardBg.svg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    .dashboard-wizard {
      display: flex;
      flex-direction: column;    
      height: 100vh;
      width: 100%;
      background-color: #f7e7fb6b;
    }
  }
}

</style>
